import React, { useState } from 'react'

import { InputText } from '@interco/inter-toranja'

interface InputProps {
  label?: string
  placeholder?: string
  type?: 'text' | 'number'
  mask?: 'email' | 'phone' | 'cep' | 'cpf' | 'date'
}

export const InputComponent: React.FC<InputProps> = ({
  label = '',
  placeholder,
  type = 'text',
  mask,
}) => {
  const [value, setValue] = useState('')

  return (
    <InputText
      label={label}
      placeholder={placeholder}
      type={type}
      mask={mask}
      value={value}
      onChange={(newValue) => setValue(newValue)}
    />
  )
}
